import { render, staticRenderFns } from "./mobileEditPlate.vue?vue&type=template&id=215c4bd0&scoped=true&"
import script from "./mobileEditPlate.vue?vue&type=script&lang=js&"
export * from "./mobileEditPlate.vue?vue&type=script&lang=js&"
import style0 from "./mobileEditPlate.vue?vue&type=style&index=0&id=215c4bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "215c4bd0",
  null
  
)

export default component.exports